import React from 'react';
import { Box, TextField, Button } from '@mui/material';

const SearchBar = ({ searchInput, setSearchInput, handleSearch }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: { xs: 'center', sm: 'flex-end' }, marginBottom: '.6rem' }}>
      <TextField
        label="Search via Scam Id"
        variant="outlined"
        size="small"
        value={searchInput}
        onChange={(e) => setSearchInput(e.target.value)}
        sx={{ marginRight: 2, width: '12rem' }}
      />
      <Button
        variant="contained"
        color="primary"
        size="small"
        onClick={handleSearch}
        sx={{ textTransform: "none" }}
      >
        Find
      </Button>
    </Box>
  );
};

export default SearchBar;
